import axios from 'axios'

export const downloadExcel = async (opts) => {
  console.log(opts)
  let res = await axios({
    method: opts.method,
    url: opts.url,
    headers: {
      // 'authorization': window.localStorage.getItem('token')
    },
    // data: opts.data,
    responseType: 'blob'
  })
  console.log(res)
  let resBlob = res.data
  if (window.navigator.msSaveBlob) { // IE以及IE内核的浏览器
    try {
      // response为接口返回数据，这里请求的时候已经处理了，如果没处理需要在此之前自行处理var data = new Blob([response.data]) 注意这里需要是数组形式的,fileNm就是下载之后的文件名
      window.navigator.msSaveBlob(resBlob, opts.fileName + '.xls')
      // window.navigator.msSaveOrOpenBlob(response, fileNm)
      // 此方法类似上面的方法，区别可自行百度
    } catch (e) {
      console.log(e)
    }
  }
  var url = window.URL.createObjectURL(resBlob)
  var a = document.createElement('a')
  a.download = opts.fileName + '.xls'
  a.href = url
  a.click()
  // window.URL.revokeObjectURL(url)

  // try {
  //   let resText = await new Promise((resolve,reject)=>{
  //     let reader = new FileReader()
  //     reader.addEventListener('abort',reject)
  //     reader.addEventListener('error',reject)
  //     reader.addEventListener('loadend',()=>{
  //       console.log(reader.result)
  //       resolve(reader.result)
  //     })
  //     reader.readAsText(resBlob)
  //   })
  // }catch (error){
  //
  // }
  return { res, resBlob }
}
